import axios from 'axios';
import Url from '../constants/Url';

class FGTimeRangeWarningApi {
    update(value) {
        return axios
            .post(Url().SET_TIME_RANGE_WARNING_STATE, {value})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to update time range warning state:', ex.message);
                throw ex;
            });
    }
}

export default new FGTimeRangeWarningApi();
